
import { defineComponent } from 'vue'

import nestjsLogo from '@/assets/imgs/logo.jpeg'

export default defineComponent({
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      title: '体育比赛一体化平台',
      logo: nestjsLogo
    }
  }
})
